import React, { useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import moment from "moment";

import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import AddJouralExerciseForm from "./add/addJournalExerciseForm";
import ConfirmDelete from "../../../sharedComponents/confirmDelete";
import { deleteFitnessJournal, getFitnessJournalSummary } from "../../../store/actions";

const CardioJournal = ({ journalSummary, data, type, date, deleteFitnessJournal, getFitnessJournalSummary, range }) => {
	const [editData, setEditData] = useState(null);
	const [deleteItem, setDeleteItem] = useState(null);

	const cardioData =
		journalSummary &&
		journalSummary.list &&
		journalSummary.list.filter((item) => {
			return item.type_of_activity === "Cardio";
		});
	const resistanceData =
		journalSummary &&
		journalSummary.list &&
		journalSummary.list.filter((item) => {
			return item.type_of_activity === "Resistance";
		});

	const felxibilityData =
		journalSummary &&
		journalSummary.list &&
		journalSummary.list.filter((item) => {
			return item.type_of_activity === "Flexibility";
		});
	const othersData =
		journalSummary &&
		journalSummary.list &&
		journalSummary.list.filter((item) => {
			return item.type_of_activity === "None";
		});

	const renderCardioData = () => {
		return (
			cardioData && (
				<PaginatedTable data={cardioData} columns={columns} className="table-default" pageSize={cardioData.length} />
			)
		);
	};
	const renderResistanceData = () => {
		return (
			resistanceData && (
				<PaginatedTable
					data={resistanceData}
					columns={columns}
					className="table-default"
					pageSize={resistanceData.length}
				/>
			)
		);
	};
	const renderFlexibilityData = () => {
		return (
			felxibilityData && (
				<PaginatedTable
					data={felxibilityData}
					columns={columns}
					className="table-default"
					pageSize={felxibilityData.length}
				/>
			)
		);
	};
	const renderOthersData = () => {
		return (
			othersData && (
				<PaginatedTable data={othersData} columns={columns} className="table-default" pageSize={othersData.length} />
			)
		);
	};

	const handleEditJournal = (editData) => {
		setEditData(editData);
	};

	const confirmDelete = (original) => {
		setDeleteItem(original);
	};

	const getFitnessJournalSummaryAPI = () => {
		getFitnessJournalSummary(`date=${moment(date ? date : new Date()).format("YYYY-MM-DD")}`);
	};

	const confirmEvent = (yes) => {
		const successHandler = (event) => {
			getFitnessJournalSummaryAPI();
		};

		yes && deleteFitnessJournal(deleteItem, successHandler);
		setDeleteItem(null);
	};

	const onUpdate = () => {
		setEditData(null);
		getFitnessJournalSummaryAPI();
	};

	const resistanceColumns = type
		? [
				{
					Header: "WEIGHT LIFTED",
					accessor: "weight_lifted",
					sortable: false,
					Cell: ({ value }) => <span> {value ? value : "-"}</span>,
					className: "text-center",
					headerClassName: "text-center",
					width: 130
				},
				{
					Header: "AMOUNT OF REPS",
					accessor: "reps",
					sortable: false,
					Cell: ({ value }) => <span> {value ? value : "-"}</span>,
					className: "text-center",
					headerClassName: "text-center",
					width: 150
				},
				{
					Header: "NUMBER OF SETS",
					accessor: "number_of_sets",
					sortable: false,
					Cell: ({ value }) => <span> {value ? value : "-"}</span>,
					className: "text-center",
					headerClassName: "text-center",
					width: 140
				}
		  ]
		: [];
	const cardioColumns = !type
		? [
				{
					Header: "MINUTES",
					accessor: "minutes",
					sortable: false,
					Cell: ({ value }) => <span> {value ? value : "-"}</span>,
					className: "text-center",
					headerClassName: "text-center",
					width: 130
				},
				{
					Header: "CALORIES BURNED",
					accessor: "calories_burned",
					sortable: false,
					Cell: ({ value }) => <span> {value ? value : "-"}</span>,
					className: "text-center",
					headerClassName: "text-center",
					width: 150
				}
		  ]
		: [];
	const columns = [
		{
			Header: "Date",
			accessor: "date",
			width: 130
		},
		{
			Header: "TYPE OF ACTIVITY",
			accessor: "exercise_title",
			sortable: false,
			Cell: ({ value }) => <span> {value ? value : "-"}</span>
		},
		...resistanceColumns,
		...cardioColumns,
		{
			Header: "Actions",
			accessor: "id",
			sortable: false,
			className: "text-right",
			headerClassName: "text-right",
			width: 130,
			Cell: ({ original }) => (
				<div>
					<button
						className="btn btn-success btn-ghost btn-cell btn-sm mr-2"
						onClick={() => handleEditJournal(original)}>
						<i className="icon icon-edit" />
					</button>
					<button className="btn btn-danger btn-ghost btn-cell btn-sm" onClick={() => confirmDelete(original)}>
						<i className="icon icon-trash" />
					</button>
				</div>
			)
		}
	];

	return (
		<div>
			{data === "cardioData" ? renderCardioData() : []}
			{data === "resistanceData" ? renderResistanceData() : []}
			{data === "felxibilityData" ? renderFlexibilityData() : []}
			{data === "othersData" ? renderOthersData() : []}
			{editData && <AddJouralExerciseForm initialValues={editData} onUpdate={onUpdate} range={range} />}
			<ConfirmDelete item={deleteItem} message={<div>Are you sure you want to delete?</div>} onEvent={confirmEvent} />
		</div>
	);
};

const mapStateToProps = (state) => ({ journalSummary: get(state.FitnessJournal, "fitnessJournalSummary", {}) });

const mapDispatchToProps = { deleteFitnessJournal, getFitnessJournalSummary };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CardioJournal);
